// import React, { useEffect } from "react";
// import ReceiptAnimation from "../../components/ReceiptAnimation"; 

// const GoogleMap = ({ apiKey, formData, overviewPolyline }) => {
//   useEffect(() => {
//     const scriptId = "google-maps-script";

//     const loadGoogleMaps = () => {
//       return new Promise((resolve) => {
//         if (window.google && window.google.maps) {
//           resolve();
//           return;
//         }

//         if (!document.getElementById(scriptId)) {
//           const script = document.createElement("script");
//           script.id = scriptId;
//           script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=geometry`;
//           script.async = true;
//           script.defer = true;
//           script.onload = () => setTimeout(resolve, 300);
//           document.body.appendChild(script);
//         } else {
//           const checkReady = setInterval(() => {
//             if (window.google && window.google.maps) {
//               clearInterval(checkReady);
//               resolve();
//             }
//           }, 200);
//         }
//       });
//     };

//     const initializeMap = () => {
//       if (!window.google?.maps) return;

//       const defaultLat = 25.276987;
//       const defaultLng = 55.296249;
//       const {
//         pickup,
//         drop,
//         twoWayPickupLocationInfo,
//         twoWayDropLocationInfo,
//       } = formData || {};

//       const routePoints = [];
//       if (pickup?.lat && pickup?.lng) routePoints.push(pickup);
//       if (drop?.lat && drop?.lng) routePoints.push(drop);
//       if (
//         twoWayPickupLocationInfo?.lat &&
//         twoWayPickupLocationInfo?.lng &&
//         !(drop?.lat === twoWayPickupLocationInfo.lat && drop?.lng === twoWayPickupLocationInfo.lng)
//       ) {
//         routePoints.push(twoWayPickupLocationInfo);
//       }
//       if (twoWayDropLocationInfo?.lat && twoWayDropLocationInfo?.lng)
//         routePoints.push(twoWayDropLocationInfo);

//       const mapElement = document.getElementById("map");
//       if (!mapElement) return;

//       const map = new window.google.maps.Map(mapElement, {
//         center: routePoints[0] || { lat: defaultLat, lng: defaultLng },
//         zoom: 12,
//         mapTypeControl: false,
//         streetViewControl: false,
//         fullscreenControl: false,
//       });

//       routePoints.forEach((point, index) => {
//         const isStart = index === 0;
//         const isEnd = index === routePoints.length - 1;
//         new window.google.maps.Marker({
//           position: { lat: point.lat, lng: point.lng },
//           map,
//           title: isStart
//             ? "Pickup Location"
//             : isEnd
//               ? "Final Drop Location"
//               : "Stop",
//           icon: isStart
//             ? "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
//             : isEnd
//               ? "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
//               : "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
//         });
//       });

//       if (overviewPolyline && window.google?.maps?.geometry) {
//         const decoded = window.google.maps.geometry.encoding.decodePath(overviewPolyline);
//         if (decoded?.length) {
//           const polyline = new window.google.maps.Polyline({
//             path: decoded,
//             geodesic: true,
//             strokeColor: "#222",
//             strokeOpacity: 0.9,
//             strokeWeight: 3,
//             map,
//           });

//           const bounds = new window.google.maps.LatLngBounds();
//           decoded.forEach((p) => bounds.extend(p));
//           routePoints.forEach((p) => bounds.extend({ lat: p.lat, lng: p.lng }));
//           map.fitBounds(bounds);
//         }
//       }
//     };

//     loadGoogleMaps().then(initializeMap);
//   }, [
//     apiKey,
//     formData?.pickup?.lat,
//     formData?.pickup?.lng,
//     formData?.drop?.lat,
//     formData?.drop?.lng,
//     formData?.twoWayPickupLocationInfo?.lat,
//     formData?.twoWayPickupLocationInfo?.lng,
//     formData?.twoWayDropLocationInfo?.lat,
//     formData?.twoWayDropLocationInfo?.lng,
//     overviewPolyline,
//   ]);

//   return (
//     <div
//       style={{
//         position: "relative",
//         width: "100%",
//         height: "100%",
//         borderRadius: "16px",
//         overflow: "hidden",
//       }}
//     >
//       <div
//         id="map"
//         style={{
//           width: "100%",
//           height: "100%",
//           borderRadius: "16px",
//         }}
//       />

//       {/* ⬇️ Receipt overlay at the bottom */}
//       <div
//         style={{
//           position: "absolute",
//           bottom: "20px",
//           left: "50%",
//           transform: "translateX(-50%)",
//           zIndex: 10,
//         }}
//       >
//         <ReceiptAnimation />
//       </div>
//     </div>
//   );
// };

// export default GoogleMap;



import React, { useEffect } from "react";
import ReceiptAnimation from "../ReceiptAnimation";

const GoogleMap = ({ apiKey, formData, overviewPolyline, totalDays, farePerTrip, totalFare }) => {
  useEffect(() => {
    const scriptId = "google-maps-script";

    const loadGoogleMaps = () => {
      return new Promise((resolve) => {
        if (window.google && window.google.maps) {
          resolve();
          return;
        }

        if (!document.getElementById(scriptId)) {
          const script = document.createElement("script");
          script.id = scriptId;
          script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=geometry`;
          script.async = true;
          script.defer = true;
          script.onload = () => setTimeout(resolve, 300);
          document.body.appendChild(script);
        } else {
          const checkReady = setInterval(() => {
            if (window.google && window.google.maps) {
              clearInterval(checkReady);
              resolve();
            }
          }, 200);
        }
      });
    };

    const initializeMap = () => {
      if (!window.google?.maps) return;

      const defaultLat = 25.276987;
      const defaultLng = 55.296249;
      const {
        pickup,
        drop,
        twoWayPickupLocationInfo,
        twoWayDropLocationInfo,
      } = formData || {};

      const routePoints = [];
      if (pickup?.lat && pickup?.lng) routePoints.push(pickup);
      if (drop?.lat && drop?.lng) routePoints.push(drop);
      if (
        twoWayPickupLocationInfo?.lat &&
        twoWayPickupLocationInfo?.lng &&
        !(drop?.lat === twoWayPickupLocationInfo.lat && drop?.lng === twoWayPickupLocationInfo.lng)
      ) {
        routePoints.push(twoWayPickupLocationInfo);
      }
      if (twoWayDropLocationInfo?.lat && twoWayDropLocationInfo?.lng)
        routePoints.push(twoWayDropLocationInfo);

      const mapElement = document.getElementById("map");
      if (!mapElement) return;

      const map = new window.google.maps.Map(mapElement, {
        center: routePoints[0] || { lat: defaultLat, lng: defaultLng },
        zoom: 12,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
      });

      routePoints.forEach((point, index) => {
        const isStart = index === 0;
        const isEnd = index === routePoints.length - 1;
        new window.google.maps.Marker({
          position: { lat: point.lat, lng: point.lng },
          map,
          title: isStart
            ? "Pickup Location"
            : isEnd
              ? "Final Drop Location"
              : "Stop",
          icon: isStart
            ? "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
            : isEnd
              ? "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
              : "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
        });
      });

      if (overviewPolyline && window.google?.maps?.geometry) {
        const decoded = window.google.maps.geometry.encoding.decodePath(overviewPolyline);
        if (decoded?.length) {
          const polyline = new window.google.maps.Polyline({
            path: decoded,
            geodesic: true,
            strokeColor: "#222",
            strokeOpacity: 0.9,
            strokeWeight: 3,
            map,
          });

          const bounds = new window.google.maps.LatLngBounds();
          decoded.forEach((p) => bounds.extend(p));
          routePoints.forEach((p) => bounds.extend({ lat: p.lat, lng: p.lng }));
          map.fitBounds(bounds);
        }
      }
    };

    loadGoogleMaps().then(initializeMap);
  }, [
    apiKey,
    formData?.pickup?.lat,
    formData?.pickup?.lng,
    formData?.drop?.lat,
    formData?.drop?.lng,
    formData?.twoWayPickupLocationInfo?.lat,
    formData?.twoWayPickupLocationInfo?.lng,
    formData?.twoWayDropLocationInfo?.lat,
    formData?.twoWayDropLocationInfo?.lng,
    overviewPolyline,
  ]);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        borderRadius: "16px",
        overflow: "hidden",
      }}
    >
      <div
        id="map"
        style={{
          width: "100%",
          height: "100%",
          borderRadius: "16px",
        }}
      />

      {/* ⬇️ Receipt overlay at the bottom */}

      {totalDays && farePerTrip &&
        <div
          style={{
            position: "absolute",
            // top:'30px',
            bottom: "0px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 10,
          }}
        >
          <ReceiptAnimation days={totalDays} tripFare={farePerTrip} totalFare={totalFare} />
        </div>
      }
    </div>
  );
};

export default GoogleMap;

